import { render, staticRenderFns } from "./AccountDisableRequestList.vue?vue&type=template&id=d5e6e264&scoped=true&"
import script from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
export * from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
import style0 from "./AccountDisableRequestList.vue?vue&type=style&index=0&id=d5e6e264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e6e264",
  null
  
)

export default component.exports